import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { ActionHelper } from '../../../helper/action.helper';
import { MatDialog } from '@angular/material/dialog';

@Component({
  templateUrl: './not-allowed-detail.component.html',
  styleUrls: ['./not-allowed-detail.component.scss'],
  standalone: false,
})
export class NotAllowedDetailComponent implements OnInit {


  constructor(
    private router: Router,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    window.scroll({ top: 0 });

    this.showAlertDialog();
  }

  showAlertDialog(): void {
    ActionHelper.showAction('ALERT-DIALOG', this.dialog, {
      titleSnippet: 'REQUEST_DETAIL_SKELETON_ENQUIRY_NO_ACCESS',
      descriptionSnippet: 'REQUEST_OVERVIEW_MESSAGE_ENQUIRY_NO_ACCESS',
      confirmButtonSnippet: 'REQUEST_DETAIL_SKELETON_ACCEPT_ENQUIRY_LINK_OVERVIEW',
      confirmButtonClass: '',
      confirmButtonIcon: '/assets/icons/arrow-short.svg',
    })?.afterClosed().subscribe(() => {
      this.goToHomePage();
    });
  }

  private goToHomePage(): void {
      this.router.navigate(['/'], { replaceUrl: true });
  }

}
